export default __webpack_public_path__ + "maps-examples-switch-styles-thumbnail-960-6b09945bd7b3d04386cef404c93503fc.webp";